import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_IRI_BUFFERING = '/dfconfigs';

export const SET_IRI_BUFFERING_LOADING = 'SET_IRI_BUFFERING_LOADING';
export const GO_TO_IRI_BUFFERING_EDIT = 'GO_TO_IRI_BUFFERING_EDIT';
export const GO_TO_IRI_BUFFERING_VIEW = 'GO_TO_IRI_BUFFERING_VIEW';
export const GO_TO_IRI_BUFFERING_COPY = 'GO_TO_IRI_BUFFERING_COPY';
export const GO_TO_IRI_BUFFERING_LIST = 'GO_TO_IRI_BUFFERING_LIST';
export const GET_IRI_BUFFERING_LIST = 'GET_IRI_BUFFERING_LIST';
export const GET_IRI_BUFFERING_LIST_PENDING = 'GET_IRI_BUFFERING_LIST_PENDING';
export const GET_IRI_BUFFERING_LIST_FULFILLED = 'GET_IRI_BUFFERING_LIST_FULFILLED';
export const GET_IRI_BUFFERING = 'GET_IRI_BUFFERING';
export const GET_IRI_BUFFERING_PENDING = 'GET_IRI_BUFFERING_PENDING';
export const GET_IRI_BUFFERING_FULFILLED = 'GET_IRI_BUFFERING_FULFILLED';
export const UPDATE_IRI_BUFFERING = 'UPDATE_IRI_BUFFERING';
export const UPDATE_IRI_BUFFERING_FULFILLED = 'UPDATE_IRI_BUFFERING_FULFILLED';
export const UPDATE_IRI_BUFFERING_REJECTED = 'UPDATE_IRI_BUFFERING_REJECTED';
export const SELECT_IRI_BUFFERING = 'SELECT_IRI_BUFFERING';

export enum IRIBufferingPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
}

export interface IRIBuffering {
  id: string
  NAME: string
  description: string
  IRISIZE: string,
  IRIEXP: string,
  IRIEXPMNT: string,
  IRICLEAR: boolean | string,
  CAUDTIME: string | null,
  CAUDPERIOD: string | null,
}

export interface IRIRBufferingState {
  entities: IRIBuffering[]
  selected: IRIBuffering[],
  single: IRIBuffering | null
  createdId: string | null
  ui: IRIBufferingUIState
}

export interface IRIBufferingUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GoToIRIBufferingListAction extends AnyAction {
  type: typeof GO_TO_IRI_BUFFERING_LIST
}

export interface SetIRIBufferingLoadingAction extends AnyAction {
  type: typeof SET_IRI_BUFFERING_LOADING
  payload: { isLoading: boolean }
}

export interface GetIRIBufferingListAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING_LIST
  payload: AxiosPromise<ServerResponse<IRIBuffering>>
}

export interface GetIRIBufferingListPendingAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING_LIST_PENDING
  payload: null
}

export interface GetIRIBufferingListFulfilledAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING_LIST_FULFILLED
  payload: AxiosResponse<ServerResponse<IRIBuffering>>
}

export interface GetIRIBufferingAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING
  payload: AxiosPromise<ServerResponse<IRIBuffering>>
}

export interface GetIRIBufferingPendingAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING_PENDING
  payload: null
}

export interface GetIRIBufferingFulfilledAction extends AnyAction {
  type: typeof GET_IRI_BUFFERING_FULFILLED
  payload: AxiosResponse<ServerResponse<IRIBuffering>>
}

export interface UpdateIRIBufferingThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}
export interface UpdateIRIBufferingAction extends AnyAction {
  type: typeof UPDATE_IRI_BUFFERING
  payload: AxiosPromise<ServerResponse<IRIBuffering>>
}

export interface UpdateIRIBufferingFulfilledAction extends AnyAction {
  type: typeof UPDATE_IRI_BUFFERING_FULFILLED
  payload: AxiosResponse<ServerResponse<IRIBuffering>>
}

export interface UpdateIRIBufferingRejectedAction extends AnyAction {
  type: typeof UPDATE_IRI_BUFFERING_REJECTED
  payload: AxiosResponse<ServerResponse<IRIBuffering>>
}

export interface SelectIRIBufferingAction extends AnyAction{
  type: typeof SELECT_IRI_BUFFERING
  payload: IRIBuffering[]
}

export type IRIBufferingActionTypes =
  GoToIRIBufferingListAction |
  SetIRIBufferingLoadingAction |
  GetIRIBufferingListAction |
  GetIRIBufferingListPendingAction |
  GetIRIBufferingListFulfilledAction |
  GetIRIBufferingAction |
  GetIRIBufferingPendingAction |
  GetIRIBufferingFulfilledAction |
  UpdateIRIBufferingAction |
  UpdateIRIBufferingFulfilledAction |
  UpdateIRIBufferingRejectedAction |
  SelectIRIBufferingAction;
